// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file src/protos/analysis_management/analysis.admin.apis.proto (package geneo.analysis.admin.apis, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { AttemptTypeEnum, PDFGenStatus } from "@protos/learning_management/lms.db_pb";

/**
 * @generated from message geneo.analysis.admin.apis.FetchAdminClassReportRequest
 */
export class FetchAdminClassReportRequest extends Message<FetchAdminClassReportRequest> {
  /**
   * @generated from field: google.protobuf.Timestamp start_date = 1;
   */
  startDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 2;
   */
  endDate?: Timestamp;

  /**
   * @generated from field: int32 school_id = 3;
   */
  schoolId = 0;

  /**
   * @generated from field: int32 class_id = 4;
   */
  classId = 0;

  /**
   * @generated from field: int64 section_id = 5;
   */
  sectionId = protoInt64.zero;

  /**
   * @generated from field: int64 admin_id = 6;
   */
  adminId = protoInt64.zero;

  /**
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 7;
   */
  attemptType?: AttemptTypeEnum;

  /**
   * "COMPLETED_ONLY" or "INCLUDE_IN_PROGRESS"
   *
   * @generated from field: optional string assessment_status = 8;
   */
  assessmentStatus?: string;

  /**
   * ["TEST", "QUIZ", "HOMEWORK"]
   *
   * @generated from field: repeated string assessment_types = 9;
   */
  assessmentTypes: string[] = [];

  constructor(data?: PartialMessage<FetchAdminClassReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.FetchAdminClassReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_date", kind: "message", T: Timestamp },
    { no: 2, name: "end_date", kind: "message", T: Timestamp },
    { no: 3, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "class_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "admin_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
    { no: 8, name: "assessment_status", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "assessment_types", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchAdminClassReportRequest {
    return new FetchAdminClassReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchAdminClassReportRequest {
    return new FetchAdminClassReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchAdminClassReportRequest {
    return new FetchAdminClassReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: FetchAdminClassReportRequest | PlainMessage<FetchAdminClassReportRequest> | undefined, b: FetchAdminClassReportRequest | PlainMessage<FetchAdminClassReportRequest> | undefined): boolean {
    return proto3.util.equals(FetchAdminClassReportRequest, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.FetchAdminClassReportResponse
 */
export class FetchAdminClassReportResponse extends Message<FetchAdminClassReportResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: optional geneo.analysis.admin.apis.AdminClassReportData data = 4;
   */
  data?: AdminClassReportData;

  constructor(data?: PartialMessage<FetchAdminClassReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.FetchAdminClassReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: AdminClassReportData, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchAdminClassReportResponse {
    return new FetchAdminClassReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchAdminClassReportResponse {
    return new FetchAdminClassReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchAdminClassReportResponse {
    return new FetchAdminClassReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: FetchAdminClassReportResponse | PlainMessage<FetchAdminClassReportResponse> | undefined, b: FetchAdminClassReportResponse | PlainMessage<FetchAdminClassReportResponse> | undefined): boolean {
    return proto3.util.equals(FetchAdminClassReportResponse, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.AdminClassReportData
 */
export class AdminClassReportData extends Message<AdminClassReportData> {
  /**
   * @generated from field: geneo.analysis.admin.apis.SchoolDetails school_details = 1;
   */
  schoolDetails?: SchoolDetails;

  /**
   * @generated from field: geneo.analysis.admin.apis.AttendanceSummary attendance = 2;
   */
  attendance?: AttendanceSummary;

  /**
   * @generated from field: repeated geneo.analysis.admin.apis.AssessmentInfo assessments = 3;
   */
  assessments: AssessmentInfo[] = [];

  /**
   * @generated from field: geneo.analysis.admin.apis.ClassSectionPerformance classSectionPerformance = 4;
   */
  classSectionPerformance?: ClassSectionPerformance;

  /**
   * @generated from field: repeated geneo.analysis.admin.apis.StudentPerformance student_performances = 5;
   */
  studentPerformances: StudentPerformance[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp created_on = 6;
   */
  createdOn?: Timestamp;

  /**
   * @generated from field: string gcp_report_url = 7;
   */
  gcpReportUrl = "";

  constructor(data?: PartialMessage<AdminClassReportData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.AdminClassReportData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "school_details", kind: "message", T: SchoolDetails },
    { no: 2, name: "attendance", kind: "message", T: AttendanceSummary },
    { no: 3, name: "assessments", kind: "message", T: AssessmentInfo, repeated: true },
    { no: 4, name: "classSectionPerformance", kind: "message", T: ClassSectionPerformance },
    { no: 5, name: "student_performances", kind: "message", T: StudentPerformance, repeated: true },
    { no: 6, name: "created_on", kind: "message", T: Timestamp },
    { no: 7, name: "gcp_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminClassReportData {
    return new AdminClassReportData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminClassReportData {
    return new AdminClassReportData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminClassReportData {
    return new AdminClassReportData().fromJsonString(jsonString, options);
  }

  static equals(a: AdminClassReportData | PlainMessage<AdminClassReportData> | undefined, b: AdminClassReportData | PlainMessage<AdminClassReportData> | undefined): boolean {
    return proto3.util.equals(AdminClassReportData, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.SchoolDetails
 */
export class SchoolDetails extends Message<SchoolDetails> {
  /**
   * @generated from field: int32 school_id = 1;
   */
  schoolId = 0;

  /**
   * @generated from field: string school_name = 2;
   */
  schoolName = "";

  /**
   * @generated from field: string class_name = 3;
   */
  className = "";

  /**
   * @generated from field: string section_name = 4;
   */
  sectionName = "";

  /**
   * @generated from field: string school_logo_url = 5;
   */
  schoolLogoUrl = "";

  /**
   * @generated from field: geneo.analysis.admin.apis.DateRange report_period = 6;
   */
  reportPeriod?: DateRange;

  constructor(data?: PartialMessage<SchoolDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.SchoolDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "school_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "class_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "section_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "school_logo_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "report_period", kind: "message", T: DateRange },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SchoolDetails {
    return new SchoolDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SchoolDetails {
    return new SchoolDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SchoolDetails {
    return new SchoolDetails().fromJsonString(jsonString, options);
  }

  static equals(a: SchoolDetails | PlainMessage<SchoolDetails> | undefined, b: SchoolDetails | PlainMessage<SchoolDetails> | undefined): boolean {
    return proto3.util.equals(SchoolDetails, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.DateRange
 */
export class DateRange extends Message<DateRange> {
  /**
   * @generated from field: google.protobuf.Timestamp start_date = 1;
   */
  startDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 2;
   */
  endDate?: Timestamp;

  constructor(data?: PartialMessage<DateRange>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.DateRange";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_date", kind: "message", T: Timestamp },
    { no: 2, name: "end_date", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DateRange {
    return new DateRange().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DateRange {
    return new DateRange().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DateRange {
    return new DateRange().fromJsonString(jsonString, options);
  }

  static equals(a: DateRange | PlainMessage<DateRange> | undefined, b: DateRange | PlainMessage<DateRange> | undefined): boolean {
    return proto3.util.equals(DateRange, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.AttendanceSummary
 */
export class AttendanceSummary extends Message<AttendanceSummary> {
  /**
   * @generated from field: int32 total_students = 1;
   */
  totalStudents = 0;

  /**
   * @generated from field: int32 present_students = 2;
   */
  presentStudents = 0;

  /**
   * @generated from field: double attendance_percentage = 3;
   */
  attendancePercentage = 0;

  /**
   * @generated from field: repeated geneo.analysis.admin.apis.AbsentStudent absent_students_list = 4;
   */
  absentStudentsList: AbsentStudent[] = [];

  constructor(data?: PartialMessage<AttendanceSummary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.AttendanceSummary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "total_students", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "present_students", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "attendance_percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "absent_students_list", kind: "message", T: AbsentStudent, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AttendanceSummary {
    return new AttendanceSummary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AttendanceSummary {
    return new AttendanceSummary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AttendanceSummary {
    return new AttendanceSummary().fromJsonString(jsonString, options);
  }

  static equals(a: AttendanceSummary | PlainMessage<AttendanceSummary> | undefined, b: AttendanceSummary | PlainMessage<AttendanceSummary> | undefined): boolean {
    return proto3.util.equals(AttendanceSummary, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.AbsentStudent
 */
export class AbsentStudent extends Message<AbsentStudent> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: string student_name = 2;
   */
  studentName = "";

  /**
   * @generated from field: optional string roll_number = 3;
   */
  rollNumber?: string;

  constructor(data?: PartialMessage<AbsentStudent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.AbsentStudent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "student_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "roll_number", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AbsentStudent {
    return new AbsentStudent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AbsentStudent {
    return new AbsentStudent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AbsentStudent {
    return new AbsentStudent().fromJsonString(jsonString, options);
  }

  static equals(a: AbsentStudent | PlainMessage<AbsentStudent> | undefined, b: AbsentStudent | PlainMessage<AbsentStudent> | undefined): boolean {
    return proto3.util.equals(AbsentStudent, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.AssessmentInfo
 */
export class AssessmentInfo extends Message<AssessmentInfo> {
  /**
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: string assessment_name = 2;
   */
  assessmentName = "";

  /**
   * @generated from field: string subject = 3;
   */
  subject = "";

  /**
   * @generated from field: repeated string chapters = 4;
   */
  chapters: string[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp conducted_date = 5;
   */
  conductedDate?: Timestamp;

  /**
   * @generated from field: int32 total_students = 6;
   */
  totalStudents = 0;

  /**
   * @generated from field: int32 submitted_count = 7;
   */
  submittedCount = 0;

  /**
   * @generated from field: double average_score = 8;
   */
  averageScore = 0;

  /**
   * @generated from field: double max_score = 9;
   */
  maxScore = 0;

  /**
   * @generated from field: double percentage_score = 10;
   */
  percentageScore = 0;

  constructor(data?: PartialMessage<AssessmentInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.AssessmentInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "chapters", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "conducted_date", kind: "message", T: Timestamp },
    { no: 6, name: "total_students", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "submitted_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "average_score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "max_score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "percentage_score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssessmentInfo {
    return new AssessmentInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssessmentInfo {
    return new AssessmentInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssessmentInfo {
    return new AssessmentInfo().fromJsonString(jsonString, options);
  }

  static equals(a: AssessmentInfo | PlainMessage<AssessmentInfo> | undefined, b: AssessmentInfo | PlainMessage<AssessmentInfo> | undefined): boolean {
    return proto3.util.equals(AssessmentInfo, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.StudentPerformance
 */
export class StudentPerformance extends Message<StudentPerformance> {
  /**
   * @generated from field: int32 rank = 1;
   */
  rank = 0;

  /**
   * @generated from field: int64 student_id = 2;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: string student_name = 3;
   */
  studentName = "";

  /**
   * @generated from field: optional string roll_number = 4;
   */
  rollNumber?: string;

  /**
   * @generated from field: int32 assessment_attempts = 5;
   */
  assessmentAttempts = 0;

  /**
   * @generated from field: double totalScore = 6;
   */
  totalScore = 0;

  /**
   * @generated from field: double maxScore = 7;
   */
  maxScore = 0;

  /**
   * @generated from field: double overall_average = 8;
   */
  overallAverage = 0;

  /**
   * @generated from field: double overall_percentage = 9;
   */
  overallPercentage = 0;

  /**
   * @generated from field: repeated geneo.analysis.admin.apis.AssessmentScore assessment_scores = 10;
   */
  assessmentScores: AssessmentScore[] = [];

  /**
   * @generated from field: repeated geneo.analysis.admin.apis.SubjectAssessmentSummary subject_assessment_summary = 11;
   */
  subjectAssessmentSummary: SubjectAssessmentSummary[] = [];

  constructor(data?: PartialMessage<StudentPerformance>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.StudentPerformance";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rank", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "student_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "roll_number", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "assessment_attempts", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "totalScore", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "maxScore", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "overall_average", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "overall_percentage", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "assessment_scores", kind: "message", T: AssessmentScore, repeated: true },
    { no: 11, name: "subject_assessment_summary", kind: "message", T: SubjectAssessmentSummary, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentPerformance {
    return new StudentPerformance().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentPerformance {
    return new StudentPerformance().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentPerformance {
    return new StudentPerformance().fromJsonString(jsonString, options);
  }

  static equals(a: StudentPerformance | PlainMessage<StudentPerformance> | undefined, b: StudentPerformance | PlainMessage<StudentPerformance> | undefined): boolean {
    return proto3.util.equals(StudentPerformance, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.AssessmentScore
 */
export class AssessmentScore extends Message<AssessmentScore> {
  /**
   * @generated from field: int64 assessment_id = 1;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: string assessment_name = 2;
   */
  assessmentName = "";

  /**
   * @generated from field: string subject = 3;
   */
  subject = "";

  /**
   * @generated from field: double score = 4;
   */
  score = 0;

  /**
   * @generated from field: double max_score = 5;
   */
  maxScore = 0;

  /**
   * @generated from field: double percentage_score = 6;
   */
  percentageScore = 0;

  /**
   * @generated from field: bool is_attempted = 7;
   */
  isAttempted = false;

  constructor(data?: PartialMessage<AssessmentScore>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.AssessmentScore";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "max_score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "percentage_score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "is_attempted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AssessmentScore {
    return new AssessmentScore().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AssessmentScore {
    return new AssessmentScore().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AssessmentScore {
    return new AssessmentScore().fromJsonString(jsonString, options);
  }

  static equals(a: AssessmentScore | PlainMessage<AssessmentScore> | undefined, b: AssessmentScore | PlainMessage<AssessmentScore> | undefined): boolean {
    return proto3.util.equals(AssessmentScore, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.SubjectAssessmentSummary
 */
export class SubjectAssessmentSummary extends Message<SubjectAssessmentSummary> {
  /**
   * @generated from field: string subject = 1;
   */
  subject = "";

  /**
   * @generated from field: double score = 2;
   */
  score = 0;

  /**
   * @generated from field: double max_score = 3;
   */
  maxScore = 0;

  /**
   * @generated from field: double percentage_score = 4;
   */
  percentageScore = 0;

  /**
   * @generated from field: bool is_attempted = 5;
   */
  isAttempted = false;

  constructor(data?: PartialMessage<SubjectAssessmentSummary>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.SubjectAssessmentSummary";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "max_score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "percentage_score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "is_attempted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubjectAssessmentSummary {
    return new SubjectAssessmentSummary().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubjectAssessmentSummary {
    return new SubjectAssessmentSummary().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubjectAssessmentSummary {
    return new SubjectAssessmentSummary().fromJsonString(jsonString, options);
  }

  static equals(a: SubjectAssessmentSummary | PlainMessage<SubjectAssessmentSummary> | undefined, b: SubjectAssessmentSummary | PlainMessage<SubjectAssessmentSummary> | undefined): boolean {
    return proto3.util.equals(SubjectAssessmentSummary, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.FetchAdminSchoolReportRequest
 */
export class FetchAdminSchoolReportRequest extends Message<FetchAdminSchoolReportRequest> {
  /**
   * @generated from field: google.protobuf.Timestamp start_date = 1;
   */
  startDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 2;
   */
  endDate?: Timestamp;

  /**
   * @generated from field: int32 school_id = 3;
   */
  schoolId = 0;

  /**
   * @generated from field: int64 admin_id = 4;
   */
  adminId = protoInt64.zero;

  /**
   * @generated from field: optional geneo.lms.db.AttemptTypeEnum attempt_type = 5;
   */
  attemptType?: AttemptTypeEnum;

  /**
   * "COMPLETED_ONLY" or "INCLUDE_IN_PROGRESS"
   *
   * @generated from field: optional string assessment_status = 6;
   */
  assessmentStatus?: string;

  /**
   * ["TEST", "QUIZ", "HOMEWORK"]
   *
   * @generated from field: repeated string assessment_types = 7;
   */
  assessmentTypes: string[] = [];

  constructor(data?: PartialMessage<FetchAdminSchoolReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.FetchAdminSchoolReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_date", kind: "message", T: Timestamp },
    { no: 2, name: "end_date", kind: "message", T: Timestamp },
    { no: 3, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "admin_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "attempt_type", kind: "enum", T: proto3.getEnumType(AttemptTypeEnum), opt: true },
    { no: 6, name: "assessment_status", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "assessment_types", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchAdminSchoolReportRequest {
    return new FetchAdminSchoolReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchAdminSchoolReportRequest {
    return new FetchAdminSchoolReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchAdminSchoolReportRequest {
    return new FetchAdminSchoolReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: FetchAdminSchoolReportRequest | PlainMessage<FetchAdminSchoolReportRequest> | undefined, b: FetchAdminSchoolReportRequest | PlainMessage<FetchAdminSchoolReportRequest> | undefined): boolean {
    return proto3.util.equals(FetchAdminSchoolReportRequest, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.FetchAdminSchoolReportResponse
 */
export class FetchAdminSchoolReportResponse extends Message<FetchAdminSchoolReportResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: optional geneo.analysis.admin.apis.AdminSchoolReportData data = 4;
   */
  data?: AdminSchoolReportData;

  constructor(data?: PartialMessage<FetchAdminSchoolReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.FetchAdminSchoolReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: AdminSchoolReportData, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchAdminSchoolReportResponse {
    return new FetchAdminSchoolReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchAdminSchoolReportResponse {
    return new FetchAdminSchoolReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchAdminSchoolReportResponse {
    return new FetchAdminSchoolReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: FetchAdminSchoolReportResponse | PlainMessage<FetchAdminSchoolReportResponse> | undefined, b: FetchAdminSchoolReportResponse | PlainMessage<FetchAdminSchoolReportResponse> | undefined): boolean {
    return proto3.util.equals(FetchAdminSchoolReportResponse, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.AdminSchoolReportData
 */
export class AdminSchoolReportData extends Message<AdminSchoolReportData> {
  /**
   * @generated from field: geneo.analysis.admin.apis.SchoolDetailsWithLogo school_details = 1;
   */
  schoolDetails?: SchoolDetailsWithLogo;

  /**
   * @generated from field: repeated geneo.analysis.admin.apis.ClassSectionPerformance class_section_performance = 2;
   */
  classSectionPerformance: ClassSectionPerformance[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp created_on = 3;
   */
  createdOn?: Timestamp;

  /**
   * @generated from field: string gcp_report_url = 4;
   */
  gcpReportUrl = "";

  constructor(data?: PartialMessage<AdminSchoolReportData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.AdminSchoolReportData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "school_details", kind: "message", T: SchoolDetailsWithLogo },
    { no: 2, name: "class_section_performance", kind: "message", T: ClassSectionPerformance, repeated: true },
    { no: 3, name: "created_on", kind: "message", T: Timestamp },
    { no: 4, name: "gcp_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminSchoolReportData {
    return new AdminSchoolReportData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminSchoolReportData {
    return new AdminSchoolReportData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminSchoolReportData {
    return new AdminSchoolReportData().fromJsonString(jsonString, options);
  }

  static equals(a: AdminSchoolReportData | PlainMessage<AdminSchoolReportData> | undefined, b: AdminSchoolReportData | PlainMessage<AdminSchoolReportData> | undefined): boolean {
    return proto3.util.equals(AdminSchoolReportData, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.SchoolDetailsWithLogo
 */
export class SchoolDetailsWithLogo extends Message<SchoolDetailsWithLogo> {
  /**
   * @generated from field: int32 school_id = 1;
   */
  schoolId = 0;

  /**
   * @generated from field: string school_name = 2;
   */
  schoolName = "";

  /**
   * @generated from field: optional string school_logo_url = 3;
   */
  schoolLogoUrl?: string;

  /**
   * @generated from field: geneo.analysis.admin.apis.DateRange report_period = 4;
   */
  reportPeriod?: DateRange;

  /**
   * @generated from field: int32 total_classes = 5;
   */
  totalClasses = 0;

  /**
   * @generated from field: int32 total_sections = 6;
   */
  totalSections = 0;

  /**
   * @generated from field: int32 total_assessments = 7;
   */
  totalAssessments = 0;

  constructor(data?: PartialMessage<SchoolDetailsWithLogo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.SchoolDetailsWithLogo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "school_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "school_logo_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "report_period", kind: "message", T: DateRange },
    { no: 5, name: "total_classes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "total_sections", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "total_assessments", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SchoolDetailsWithLogo {
    return new SchoolDetailsWithLogo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SchoolDetailsWithLogo {
    return new SchoolDetailsWithLogo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SchoolDetailsWithLogo {
    return new SchoolDetailsWithLogo().fromJsonString(jsonString, options);
  }

  static equals(a: SchoolDetailsWithLogo | PlainMessage<SchoolDetailsWithLogo> | undefined, b: SchoolDetailsWithLogo | PlainMessage<SchoolDetailsWithLogo> | undefined): boolean {
    return proto3.util.equals(SchoolDetailsWithLogo, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.ClassSectionPerformance
 */
export class ClassSectionPerformance extends Message<ClassSectionPerformance> {
  /**
   * @generated from field: int32 class_id = 1;
   */
  classId = 0;

  /**
   * @generated from field: string class_name = 2;
   */
  className = "";

  /**
   * @generated from field: int64 section_id = 3;
   */
  sectionId = protoInt64.zero;

  /**
   * @generated from field: string section_name = 4;
   */
  sectionName = "";

  /**
   * @generated from field: repeated geneo.analysis.admin.apis.SubjectPerformance subject_performance = 5;
   */
  subjectPerformance: SubjectPerformance[] = [];

  constructor(data?: PartialMessage<ClassSectionPerformance>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.ClassSectionPerformance";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "class_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "class_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "section_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "subject_performance", kind: "message", T: SubjectPerformance, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClassSectionPerformance {
    return new ClassSectionPerformance().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClassSectionPerformance {
    return new ClassSectionPerformance().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClassSectionPerformance {
    return new ClassSectionPerformance().fromJsonString(jsonString, options);
  }

  static equals(a: ClassSectionPerformance | PlainMessage<ClassSectionPerformance> | undefined, b: ClassSectionPerformance | PlainMessage<ClassSectionPerformance> | undefined): boolean {
    return proto3.util.equals(ClassSectionPerformance, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.SubjectPerformance
 */
export class SubjectPerformance extends Message<SubjectPerformance> {
  /**
   * @generated from field: string subject = 1;
   */
  subject = "";

  /**
   * @generated from field: int32 subject_id = 2;
   */
  subjectId = 0;

  /**
   * @generated from field: repeated geneo.analysis.admin.apis.ChapterPerformance chapter_performance = 3;
   */
  chapterPerformance: ChapterPerformance[] = [];

  constructor(data?: PartialMessage<SubjectPerformance>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.SubjectPerformance";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "chapter_performance", kind: "message", T: ChapterPerformance, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubjectPerformance {
    return new SubjectPerformance().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubjectPerformance {
    return new SubjectPerformance().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubjectPerformance {
    return new SubjectPerformance().fromJsonString(jsonString, options);
  }

  static equals(a: SubjectPerformance | PlainMessage<SubjectPerformance> | undefined, b: SubjectPerformance | PlainMessage<SubjectPerformance> | undefined): boolean {
    return proto3.util.equals(SubjectPerformance, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.ChapterPerformance
 */
export class ChapterPerformance extends Message<ChapterPerformance> {
  /**
   * @generated from field: int32 chapter_id = 1;
   */
  chapterId = 0;

  /**
   * @generated from field: string chapter_name = 2;
   */
  chapterName = "";

  /**
   * @generated from field: double average_score = 3;
   */
  averageScore = 0;

  /**
   * @generated from field: double percentage_score = 4;
   */
  percentageScore = 0;

  /**
   * @generated from field: repeated geneo.analysis.admin.apis.StudentPerf student_performances = 5;
   */
  studentPerformances: StudentPerf[] = [];

  constructor(data?: PartialMessage<ChapterPerformance>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.ChapterPerformance";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "chapter_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "chapter_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "average_score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "percentage_score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "student_performances", kind: "message", T: StudentPerf, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChapterPerformance {
    return new ChapterPerformance().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChapterPerformance {
    return new ChapterPerformance().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChapterPerformance {
    return new ChapterPerformance().fromJsonString(jsonString, options);
  }

  static equals(a: ChapterPerformance | PlainMessage<ChapterPerformance> | undefined, b: ChapterPerformance | PlainMessage<ChapterPerformance> | undefined): boolean {
    return proto3.util.equals(ChapterPerformance, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.StudentPerf
 */
export class StudentPerf extends Message<StudentPerf> {
  /**
   * @generated from field: string student_id = 2;
   */
  studentId = "";

  /**
   * @generated from field: double score = 6;
   */
  score = 0;

  /**
   * @generated from field: double maxScore = 7;
   */
  maxScore = 0;

  constructor(data?: PartialMessage<StudentPerf>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.StudentPerf";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 2, name: "student_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "maxScore", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentPerf {
    return new StudentPerf().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentPerf {
    return new StudentPerf().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentPerf {
    return new StudentPerf().fromJsonString(jsonString, options);
  }

  static equals(a: StudentPerf | PlainMessage<StudentPerf> | undefined, b: StudentPerf | PlainMessage<StudentPerf> | undefined): boolean {
    return proto3.util.equals(StudentPerf, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.UpdateReportPDFUrlAndStatusRequest
 */
export class UpdateReportPDFUrlAndStatusRequest extends Message<UpdateReportPDFUrlAndStatusRequest> {
  /**
   * @generated from field: int64 report_id = 1;
   */
  reportId = protoInt64.zero;

  /**
   * @generated from field: string gcp_report_url = 2;
   */
  gcpReportUrl = "";

  /**
   * @generated from field: geneo.lms.db.PDFGenStatus status = 3;
   */
  status = PDFGenStatus.PDF_GENERATION_STATUS_UNDEFINED;

  constructor(data?: PartialMessage<UpdateReportPDFUrlAndStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.UpdateReportPDFUrlAndStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "report_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "gcp_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(PDFGenStatus) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateReportPDFUrlAndStatusRequest {
    return new UpdateReportPDFUrlAndStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateReportPDFUrlAndStatusRequest {
    return new UpdateReportPDFUrlAndStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateReportPDFUrlAndStatusRequest {
    return new UpdateReportPDFUrlAndStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateReportPDFUrlAndStatusRequest | PlainMessage<UpdateReportPDFUrlAndStatusRequest> | undefined, b: UpdateReportPDFUrlAndStatusRequest | PlainMessage<UpdateReportPDFUrlAndStatusRequest> | undefined): boolean {
    return proto3.util.equals(UpdateReportPDFUrlAndStatusRequest, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.UpdateReportPDFUrlAndStatusResponse
 */
export class UpdateReportPDFUrlAndStatusResponse extends Message<UpdateReportPDFUrlAndStatusResponse> {
  constructor(data?: PartialMessage<UpdateReportPDFUrlAndStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.UpdateReportPDFUrlAndStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateReportPDFUrlAndStatusResponse {
    return new UpdateReportPDFUrlAndStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateReportPDFUrlAndStatusResponse {
    return new UpdateReportPDFUrlAndStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateReportPDFUrlAndStatusResponse {
    return new UpdateReportPDFUrlAndStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateReportPDFUrlAndStatusResponse | PlainMessage<UpdateReportPDFUrlAndStatusResponse> | undefined, b: UpdateReportPDFUrlAndStatusResponse | PlainMessage<UpdateReportPDFUrlAndStatusResponse> | undefined): boolean {
    return proto3.util.equals(UpdateReportPDFUrlAndStatusResponse, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.FetchTeacherPerformanceReportRequest
 */
export class FetchTeacherPerformanceReportRequest extends Message<FetchTeacherPerformanceReportRequest> {
  /**
   * @generated from field: google.protobuf.Timestamp start_date = 1;
   */
  startDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 2;
   */
  endDate?: Timestamp;

  /**
   * @generated from field: int32 school_id = 3;
   */
  schoolId = 0;

  /**
   * @generated from field: int64 admin_id = 4;
   */
  adminId = protoInt64.zero;

  constructor(data?: PartialMessage<FetchTeacherPerformanceReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.FetchTeacherPerformanceReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_date", kind: "message", T: Timestamp },
    { no: 2, name: "end_date", kind: "message", T: Timestamp },
    { no: 3, name: "school_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "admin_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchTeacherPerformanceReportRequest {
    return new FetchTeacherPerformanceReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchTeacherPerformanceReportRequest {
    return new FetchTeacherPerformanceReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchTeacherPerformanceReportRequest {
    return new FetchTeacherPerformanceReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: FetchTeacherPerformanceReportRequest | PlainMessage<FetchTeacherPerformanceReportRequest> | undefined, b: FetchTeacherPerformanceReportRequest | PlainMessage<FetchTeacherPerformanceReportRequest> | undefined): boolean {
    return proto3.util.equals(FetchTeacherPerformanceReportRequest, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.SectionTopicPerformance
 */
export class SectionTopicPerformance extends Message<SectionTopicPerformance> {
  /**
   * @generated from field: string topic = 1;
   */
  topic = "";

  /**
   * @generated from field: int32 weekly_exams = 2;
   */
  weeklyExams = 0;

  /**
   * @generated from field: int32 avg_score = 3;
   */
  avgScore = 0;

  /**
   * @generated from field: int32 total_activities = 4;
   */
  totalActivities = 0;

  /**
   * @generated from field: int32 completed_activities = 5;
   */
  completedActivities = 0;

  constructor(data?: PartialMessage<SectionTopicPerformance>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.SectionTopicPerformance";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "topic", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "weekly_exams", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "avg_score", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "total_activities", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "completed_activities", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SectionTopicPerformance {
    return new SectionTopicPerformance().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SectionTopicPerformance {
    return new SectionTopicPerformance().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SectionTopicPerformance {
    return new SectionTopicPerformance().fromJsonString(jsonString, options);
  }

  static equals(a: SectionTopicPerformance | PlainMessage<SectionTopicPerformance> | undefined, b: SectionTopicPerformance | PlainMessage<SectionTopicPerformance> | undefined): boolean {
    return proto3.util.equals(SectionTopicPerformance, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.ReportSection
 */
export class ReportSection extends Message<ReportSection> {
  /**
   * @generated from field: string className = 1;
   */
  className = "";

  /**
   * @generated from field: string sectionName = 2;
   */
  sectionName = "";

  /**
   * @generated from field: repeated geneo.analysis.admin.apis.SectionTopicPerformance topics = 3;
   */
  topics: SectionTopicPerformance[] = [];

  constructor(data?: PartialMessage<ReportSection>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.ReportSection";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "className", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sectionName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "topics", kind: "message", T: SectionTopicPerformance, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportSection {
    return new ReportSection().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportSection {
    return new ReportSection().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportSection {
    return new ReportSection().fromJsonString(jsonString, options);
  }

  static equals(a: ReportSection | PlainMessage<ReportSection> | undefined, b: ReportSection | PlainMessage<ReportSection> | undefined): boolean {
    return proto3.util.equals(ReportSection, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.ReportCourse
 */
export class ReportCourse extends Message<ReportCourse> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: repeated geneo.analysis.admin.apis.ReportSection sections = 2;
   */
  sections: ReportSection[] = [];

  constructor(data?: PartialMessage<ReportCourse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.ReportCourse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sections", kind: "message", T: ReportSection, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReportCourse {
    return new ReportCourse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReportCourse {
    return new ReportCourse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReportCourse {
    return new ReportCourse().fromJsonString(jsonString, options);
  }

  static equals(a: ReportCourse | PlainMessage<ReportCourse> | undefined, b: ReportCourse | PlainMessage<ReportCourse> | undefined): boolean {
    return proto3.util.equals(ReportCourse, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.TeacherPerformanceData
 */
export class TeacherPerformanceData extends Message<TeacherPerformanceData> {
  /**
   * @generated from field: string teacher_name = 1;
   */
  teacherName = "";

  /**
   * @generated from field: repeated geneo.analysis.admin.apis.ReportCourse courses = 2;
   */
  courses: ReportCourse[] = [];

  /**
   * @generated from field: string remarks = 3;
   */
  remarks = "";

  constructor(data?: PartialMessage<TeacherPerformanceData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.TeacherPerformanceData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "courses", kind: "message", T: ReportCourse, repeated: true },
    { no: 3, name: "remarks", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherPerformanceData {
    return new TeacherPerformanceData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherPerformanceData {
    return new TeacherPerformanceData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherPerformanceData {
    return new TeacherPerformanceData().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherPerformanceData | PlainMessage<TeacherPerformanceData> | undefined, b: TeacherPerformanceData | PlainMessage<TeacherPerformanceData> | undefined): boolean {
    return proto3.util.equals(TeacherPerformanceData, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.TeacherPerformanceReportData
 */
export class TeacherPerformanceReportData extends Message<TeacherPerformanceReportData> {
  /**
   * URL for the report stored in GCP
   *
   * @generated from field: optional string gcp_report_url = 1;
   */
  gcpReportUrl?: string;

  /**
   * @generated from field: geneo.analysis.admin.apis.SchoolDetailsWithLogo school_details = 2;
   */
  schoolDetails?: SchoolDetailsWithLogo;

  /**
   * @generated from field: repeated geneo.analysis.admin.apis.TeacherPerformanceData teacher_performance = 3;
   */
  teacherPerformance: TeacherPerformanceData[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp created_on = 4;
   */
  createdOn?: Timestamp;

  constructor(data?: PartialMessage<TeacherPerformanceReportData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.TeacherPerformanceReportData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "gcp_report_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "school_details", kind: "message", T: SchoolDetailsWithLogo },
    { no: 3, name: "teacher_performance", kind: "message", T: TeacherPerformanceData, repeated: true },
    { no: 4, name: "created_on", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TeacherPerformanceReportData {
    return new TeacherPerformanceReportData().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TeacherPerformanceReportData {
    return new TeacherPerformanceReportData().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TeacherPerformanceReportData {
    return new TeacherPerformanceReportData().fromJsonString(jsonString, options);
  }

  static equals(a: TeacherPerformanceReportData | PlainMessage<TeacherPerformanceReportData> | undefined, b: TeacherPerformanceReportData | PlainMessage<TeacherPerformanceReportData> | undefined): boolean {
    return proto3.util.equals(TeacherPerformanceReportData, a, b);
  }
}

/**
 * @generated from message geneo.analysis.admin.apis.FetchTeacherPerformanceReportResponse
 */
export class FetchTeacherPerformanceReportResponse extends Message<FetchTeacherPerformanceReportResponse> {
  /**
   * Response status
   *
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * Response code
   *
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * Response message
   *
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: geneo.analysis.admin.apis.TeacherPerformanceReportData data = 4;
   */
  data?: TeacherPerformanceReportData;

  constructor(data?: PartialMessage<FetchTeacherPerformanceReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.analysis.admin.apis.FetchTeacherPerformanceReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: TeacherPerformanceReportData },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchTeacherPerformanceReportResponse {
    return new FetchTeacherPerformanceReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchTeacherPerformanceReportResponse {
    return new FetchTeacherPerformanceReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchTeacherPerformanceReportResponse {
    return new FetchTeacherPerformanceReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: FetchTeacherPerformanceReportResponse | PlainMessage<FetchTeacherPerformanceReportResponse> | undefined, b: FetchTeacherPerformanceReportResponse | PlainMessage<FetchTeacherPerformanceReportResponse> | undefined): boolean {
    return proto3.util.equals(FetchTeacherPerformanceReportResponse, a, b);
  }
}

